import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaintenance = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 299.66,
	height: 247.089,
	viewBox: "0 0 299.66 247.089",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_10345",
		"data-name": "Group 10345",
		transform: "translate(-492 -304.93)",
		children: [
			/* @__PURE__ */ _jsx("line", {
				id: "Line_1507",
				"data-name": "Line 1507",
				x2: 40.5,
				transform: "translate(542 549.02)",
				fill: "none",
				stroke: "#f2f3f5",
				strokeLinecap: "round",
				strokeWidth: 6
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_1508",
				"data-name": "Line 1508",
				x2: 41,
				transform: "translate(694.5 549.02)",
				fill: "none",
				stroke: "#f2f3f5",
				strokeLinecap: "round",
				strokeWidth: 6
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_685",
				"data-name": "Ellipse 685",
				cx: 105,
				cy: 105,
				r: 105,
				transform: "translate(747 534) rotate(180)",
				fill: "#e1edf5",
				opacity: .417
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_1506",
				"data-name": "Line 1506",
				x2: 6,
				y2: 6,
				transform: "translate(589.5 457.5)",
				fill: "none",
				stroke: "#97a7bf",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_10344",
				"data-name": "Group 10344",
				children: [
					/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse_673",
						"data-name": "Ellipse 673",
						cx: 5.348,
						cy: 5.349,
						rx: 5.348,
						ry: 5.349,
						transform: "translate(791.66 486.629) rotate(180)",
						fill: "#a5afbc",
						opacity: .476
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse_674",
						"data-name": "Ellipse 674",
						cx: 4.078,
						cy: 4.078,
						rx: 4.078,
						ry: 4.078,
						transform: "translate(570.855 447.662) rotate(180)",
						fill: "#a5afbc",
						opacity: .476
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10205",
						"data-name": "Path 10205",
						d: "M8.8,0,9.988,5.249l5,2L10.358,10,10,15.366l-4.043-3.55L.739,13.134,2.866,8.192,0,3.637l5.358.5Z",
						transform: "translate(520.348 345.932) rotate(180)",
						fill: "#a5afbc",
						opacity: .476
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10316",
						"data-name": "Path 10316",
						d: "M6.89,0l.927,4.108,3.91,1.565L8.106,7.824l-.28,4.2L4.661,9.248.578,10.279,2.243,6.411,0,2.847l4.193.388Z",
						transform: "translate(767.299 366.039) rotate(-150)",
						fill: "#a5afbc",
						opacity: .476
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10206",
						"data-name": "Path 10206",
						d: "M4.025,0,5.269,2.521l2.782.4L6.038,4.887l.475,2.77L4.025,6.349,1.538,7.657l.475-2.77L0,2.925l2.781-.4Z",
						transform: "translate(669.615 353.59) rotate(180)",
						fill: "#a5afbc",
						opacity: .476
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_784",
						"data-name": "Rectangle 784",
						width: 9.029,
						height: 9.029,
						transform: "matrix(-0.995, -0.105, 0.105, -0.995, 749.479, 427.961)",
						fill: "#a5afbc",
						opacity: .476
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_805",
						"data-name": "Rectangle 805",
						width: 4.514,
						height: 4.514,
						transform: "matrix(-0.866, 0.5, -0.5, -0.866, 600.938, 308.84)",
						fill: "#a5afbc",
						opacity: .476
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle_814",
						"data-name": "Rectangle 814",
						width: 13,
						height: 13,
						transform: "translate(492 403)",
						fill: "#d4d9df"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_10343",
				"data-name": "Group 10343",
				transform: "translate(491.708 279)",
				children: [
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_10341",
						"data-name": "Group 10341",
						children: [
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_10339",
								"data-name": "Group 10339",
								children: [/* @__PURE__ */ _jsx("path", {
									id: "Path_10361",
									"data-name": "Path 10361",
									d: "M207.64,240.534l-.007-.007a23.319,23.319,0,0,1-5.819-23.3c.138-.459.295-.914.463-1.366.209-.535.437-1.064.691-1.581l-.023-.023-1.7-1.7L100.383,111.7a33.028,33.028,0,0,0,6.365-4.963L92.957,92.942l-4.615,4.6H75.3L58.543,80.763a4.7,4.7,0,0,0-4.768-1.211,4.774,4.774,0,0,0-3.48,4.768,33.068,33.068,0,0,0,47.329,28.859L199.961,215.517a25.57,25.57,0,0,0,42.264,26.594l-1.577-1.577-.007.007A23.332,23.332,0,0,1,207.64,240.534Z",
									fill: "#c2c9cc"
								}), /* @__PURE__ */ _jsx("path", {
									id: "Path_10362",
									"data-name": "Path 10362",
									d: "M229.233,206.863H219.059a4.852,4.852,0,0,0-3.455,1.43l0,0-3.6,3.6,1.414,1.414,3.6-3.6,0,0a2.864,2.864,0,0,1,2.041-.845h10.174a2.872,2.872,0,0,1,2.043.847l7.192,7.191a2.914,2.914,0,0,1,.846,2.044v10.166a2.871,2.871,0,0,1-.846,2.043l-3.6,3.6,1.415,1.414,3.6-3.6a4.857,4.857,0,0,0,1.432-3.457V218.945a4.925,4.925,0,0,0-1.432-3.458l-7.191-7.191A4.863,4.863,0,0,0,229.233,206.863Z",
									fill: "#c2c9cc"
								})]
							}),
							/* @__PURE__ */ _jsxs("g", {
								id: "Group_10340",
								"data-name": "Group 10340",
								children: [/* @__PURE__ */ _jsx("path", {
									id: "Path_10363",
									"data-name": "Path 10363",
									d: "M215.517,199.961,113.2,97.639A33.073,33.073,0,0,0,84.32,50.29v0A4.713,4.713,0,0,0,79.6,53.747a4.771,4.771,0,0,0,1.211,4.768L97.583,75.284,97.569,88.34l-4.613,4.6,13.791,13.791c.049-.049.1-.091.154-.141a33.1,33.1,0,0,0,4.809-6.194L212.555,201.24l1.7,1.7.023.024c.52-.251,1.049-.476,1.584-.684.453-.168.909-.325,1.37-.464a23.339,23.339,0,0,1,23.419,38.721l1.577,1.577a25.569,25.569,0,0,0-26.708-42.15Z",
									fill: "#e8eaeb"
								}), /* @__PURE__ */ _jsx("path", {
									id: "Path_10364",
									"data-name": "Path 10364",
									d: "M234.872,234.754l-3.6,3.6a2.918,2.918,0,0,1-2.045.846H219.059a2.869,2.869,0,0,1-2.043-.846l-7.191-7.192a2.875,2.875,0,0,1-.848-2.043V218.95a2.877,2.877,0,0,1,.848-2.044l3.6-3.6-1.415-1.414-3.6,3.6a4.857,4.857,0,0,0-1.434,3.458v10.17a4.857,4.857,0,0,0,1.433,3.456l7.192,7.193a4.861,4.861,0,0,0,3.457,1.431h10.169a4.869,4.869,0,0,0,3.459-1.431l3.6-3.6Z",
									fill: "#e8eaeb"
								})]
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_10365",
								"data-name": "Path 10365",
								d: "M214.232,202.918l-44.448-44.434-15.514-15.5-22.9-22.9L128.5,139.795v.014l31.176,31.162,15.507,15.507,27.754,27.74a23.343,23.343,0,1,0,37.674-6.619l-.014-.014A23.363,23.363,0,0,0,214.232,202.918Zm25.647,12.565a4.926,4.926,0,0,1,1.436,3.458v10.168a4.865,4.865,0,0,1-1.436,3.458l-3.6,3.6.007.007-3.6,3.6a4.867,4.867,0,0,1-3.465,1.428H219.055a4.858,4.858,0,0,1-3.451-1.428l-7.2-7.2a4.857,4.857,0,0,1-1.429-3.45V218.955a4.865,4.865,0,0,1,1.429-3.464L215.6,208.3l.007-.007a4.858,4.858,0,0,1,3.451-1.428h10.182a4.858,4.858,0,0,1,3.451,1.428Z",
								fill: "#d7dcdd"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Path_10366",
								"data-name": "Path 10366",
								d: "M79.564,53.754a4.721,4.721,0,0,0,1.209,4.773L97.56,75.285V88.324l-9.2,9.228-13.053.014L58.527,80.8a4.763,4.763,0,0,0-4.758-1.209,29.888,29.888,0,0,0,41.5,31.233l.007-.007a25.617,25.617,0,0,0,2.828-1.4h0l15.315,15.3L128.5,139.795l2.871-19.714,15.9,15.9.015-.014L124.105,112.8l-7.97-7.954-6.728-6.729.011-.017a24.043,24.043,0,0,0,1.407-2.836A29.887,29.887,0,0,0,79.564,53.754Z",
								fill: "#dee0e0"
							})
						]
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10367",
						"data-name": "Path 10367",
						d: "M165.635,155.181h0l.4-.4,1.065-3.193L161,145.48l-15.556,15.556,14.992,14.992,3.173-1.044,1.018-1.019,1.011-1.011A12.567,12.567,0,0,0,165.635,155.181Z",
						opacity: .08,
						style: {
							mixBlendMode: "darken",
							isolation: "isolate"
						}
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10368",
						"data-name": "Path 10368",
						d: "M155.726,155.587l-11.314-11.314,5.657-5.656,11.313,11.313Z",
						fill: "#5a7293"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Group_10328",
						"data-name": "Group 10328",
						d: "M161.451,150,150,138.547a3.943,3.943,0,0,1,.082-5.574l16.947,16.947A3.944,3.944,0,0,1,161.451,150Z",
						fill: "#5a7293"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Group_10329",
						"data-name": "Group 10329",
						d: "M155.646,132.884l11.469,11.469a3.943,3.943,0,0,1-.078,5.578h0l-16.969-16.969a3.945,3.945,0,0,1,5.577-.08Z",
						fill: "#8094b1"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Group_10333",
						"data-name": "Group 10333",
						d: "M164.209,141.446l-5.657-5.656,70.741-70.741,5.657,5.657Z",
						fill: "#cdd1d3"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Group_10337",
						"data-name": "Group 10337",
						d: "M148.653,140.032l5.656,5.657a3,3,0,0,1,0,4.243l-2.121,2.121h0l-7.778-7.778h0l4.243-4.243Z",
						fill: "#8094b1"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10369",
						"data-name": "Path 10369",
						d: "M240.571,67.913l-8.485-8.485-2.849,5.637,5.7,5.7Z",
						fill: "#cdd1d3"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10370",
						"data-name": "Path 10370",
						d: "M240.571,67.913l-5.636,2.85-.021-.021-70.7,70.7-2.828-2.828,70.7-70.7-2.85-2.85,2.85-5.636Z",
						opacity: .2
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10371",
						"data-name": "Path 10371",
						d: "M232.082,59.431l8.485,8.485,8.506-11.293-5.7-5.7Z",
						fill: "#cdd1d3"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10372",
						"data-name": "Path 10372",
						d: "M155.728,175.385,87.846,243.267a22,22,0,0,1-31.113,0,22.034,22.034,0,0,1-6.307-13.138,21.945,21.945,0,0,1,6.307-17.975l67.882-67.882a14,14,0,0,1,19.8,0l11.314,11.314A14,14,0,0,1,155.728,175.385Z",
						fill: "#8094b1"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10373",
						"data-name": "Path 10373",
						d: "M155.68,175.433,88.242,242.871c-8.6,8.6-23.029,8.96-31.587.317A21.669,21.669,0,0,1,52.59,237.5a21.957,21.957,0,0,0,25.356-4.13l68.42-68.419a13.234,13.234,0,0,0,.007-18.717l9.307,9.307A14.068,14.068,0,0,1,155.68,175.433Z",
						fill: "#5a7293"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_10374",
						"data-name": "Path 10374",
						d: "M127.812,163.647,62.758,228.7a9.988,9.988,0,0,1-12.332,1.428,21.945,21.945,0,0,1,6.307-17.975L123.6,145.29l4.215,4.215A10,10,0,0,1,127.812,163.647Z",
						fill: "#97a7bf"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_10342",
						"data-name": "Group 10342",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_10375",
							"data-name": "Path 10375",
							d: "M111.989,172.427l10.275-10.275a5.771,5.771,0,0,0-.348-8.138l-14.17,14.17Z",
							fill: "#f2f7fa"
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Rectangle_815",
						"data-name": "Rectangle 815",
						d: "M0,0H6A0,0,0,0,1,6,0V3.226A2.774,2.774,0,0,1,3.226,6H0A0,0,0,0,1,0,6V0A0,0,0,0,1,0,0Z",
						transform: "translate(105.625 170.305) rotate(45)",
						fill: "#f2f7fa"
					})
				]
			})
		]
	})
});
export default SvgMaintenance;
